import { PointerEvent } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { IconCornerUpRight } from "common/assets";
import { actions } from "features/creator/slice";
import { useActionCommand } from "features/creator/utils";
import { ActionCommandType } from "features/creator/types";

export const RedoBtn = () => {
  const play = usePlaySound();
  const dispatch = useDispatch();
  const handleAction = useActionCommand();
  const stacks = useSelector((state: RootState) => state.creator.redoStacks);
  const disabled = stacks.length === 0;
  const handleRedo = (e: PointerEvent) => {
    play();
    e.stopPropagation();
    if (disabled) return;
    dispatch(actions.handleAllCollapse());
    handleAction({ type: ActionCommandType.REDO });
    toast.info(
      <div>
        <p className="text text-textcolor-black">{I18n.t("MSG_TOAST_REDO")}</p>
      </div>,
    );
  };

  return (
    <div className="flex-col-el flex-center h-full relative upsilon-square">
      <button
        id="creator-redo-btn"
        className="btn btn-blue"
        disabled={disabled}
        onPointerDown={handleRedo}
      >
        <div className="flex-col-el flex-center relative w-[32px] h-[32px] mb-[3px]">
          <IconCornerUpRight />
        </div>
      </button>
    </div>
  );
};
